import { z } from 'zod';

/**
 * One row of public.admin_tenant_overview() -- the same figures the tenant
 * dashboard shows, but for every tenant at once.
 *
 * Numeric columns arrive as strings from PostgREST when the underlying type is
 * `numeric`, so revenue and the rating are coerced rather than assumed.
 */
export const AdminTenantOverviewRowSchema = z.object({
  tenant_id: z.string().uuid(),
  tenant_name: z.string(),
  slug: z.string().nullable(),
  package: z.string().nullable(),
  deactivated_at: z.string().nullable(),
  new_customers_7d: z.coerce.number(),
  new_customers_prev_7d: z.coerce.number(),
  new_leads_7d: z.coerce.number(),
  new_leads_prev_7d: z.coerce.number(),
  revenue_7d: z.coerce.number(),
  revenue_prev_7d: z.coerce.number(),
  avg_rating: z.coerce.number().nullable(),
  review_count: z.coerce.number(),
  new_reviews_7d: z.coerce.number(),
  new_reviews_prev_7d: z.coerce.number(),
  reviews_answered: z.coerce.number(),
  reviews_total: z.coerce.number(),
  last_appointment_at: z.string().nullable(),
  last_message_at: z.string().nullable(),
});

export type AdminTenantOverviewRow = z.infer<typeof AdminTenantOverviewRowSchema>;

export const AdminTenantOverviewSchema = z.array(AdminTenantOverviewRowSchema);

/** Return value of public.set_tenant_deactivated(): the new deactivated_at. */
export const SetTenantDeactivatedResultSchema = z.string().nullable();
